import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function TraiesteProblem() {
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-2113">
      <div className="max-w-4xl mx-auto px-6" data-id="element-2114">
        <SectionHeading title="Simți că viața trece pe lângă tine fără să o trăiești cu adevărat?" data-id="element-2115" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-brand-cream rounded-3xl p-8 md:p-12 shadow-sm border border-brand-text/5 mb-12" data-id="element-2116">
          <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed" data-id="element-2117">
            <p className="font-bold text-xl text-brand-text" data-id="element-2118">
              Ai o viață care arată bine din exterior. Dar în interior simți că
              lipsește ceva.
            </p>
            <p data-id="element-2119">
              Poate ai un job, o familie, un salariu. Lucruri pentru care alții
              te-ar invidia. Și totuși nu ești pe deplin împlinită. Trăiești pe
              pilot automat, oscilezi între dorință și confuzie, între stresul
              prezentului și neliniștea viitorului. Și simți că nu îți
              împlinești adevăratul potențial.
            </p>
            <p data-id="element-2120">
              Cu fiecare zi în care continui așa, distanța dintre viața pe care
              o trăiești și viața pe care ți-o dorești crește. Visurile rămân
              doar gânduri. Sensul se estompează. Și sentimentul că îți irosești
              anii devine tot mai greu de suportat. Nu e despre a avea mai mult.
              E despre a trăi cu adevărat ceea ce ai.
            </p>

            <div className="mt-8 p-6 bg-brand-gold/5 border-l-4 border-brand-gold rounded-r-xl" data-id="element-2121">
              <p className="font-medium text-brand-text italic" data-id="element-2122">
                Cursul Trăiește în Prezent și Împlinește-ți Visul te ghidează să
                descoperi și să practici cele 7 legi spirituale ale succesului,
                să accesezi conștiința bogăției, să aplici exerciții practice
                pentru sănătate și echilibru și să cultivi recunoștința și
                iubirea în fiecare zi. Nu e doar un curs despre prosperitate. E
                un curs despre cum să îți trăiești viața conștient, cu sens, și
                să îți transformi visurile în realitate.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-2123">
          <CTAButton data-id="element-2124" />
        </motion.div>
      </div>
    </section>;
}